import React from 'react'

import Hero from "./hero";
import About from "./about";
import Experience from "./experience";
import Projects from "./projects";

export default function home() {
   return (
      <div>
         <Hero />
         <About />
         <Experience />
         <Projects />




      </div>
   )
}
